import React, { Component } from 'react';
import TitlePage from '../../containers/Header/TitlePage';
import NavBar from '../../containers/Header/NavBar';
import { Container, Row, Col } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { submitRec, resetRecError } from '../../actions/recommendations';
import RecommendationsForm from './RecommendationsForm';
import './RecommendationsPage.css';
import { recFormToResource, hasKeys } from '../simpleFunctions';

class RecommendationsPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // Use: used to check if the form has changed since the last reload/last submission
      changed: false,
    };
  }

  handleSave() {
    // Use: reset changed as the form has been saved
    this.setState({
      changed: false,
    });

    let followUp = '';
    let detailed = '';

    if (!hasKeys(this.props, 'recommendations.detailed.resource') && !hasKeys(this.props, 'recommendations.followUp.resource')) {
      /*
      * These are the DEFAULT parameter values.
      * Reasoning for the parameter values:
      * - this.props.formValues.values.followUp/detailed: this the form object that needs to be mapped to an Observation resource
      * - "Follow-Up"/"Detailed": the type of the recommendation, this either followUp or Detailed
      * - this.props.patient.resource.id: The patient's id to help with forming the Observation resource
      * - this.props.user.id: The clinician's id to help with the forming the Observation resource
      * - null: this is the Observation resource that exists, unless it's a POST where this would be null
      */
      // Use: for the default values especially if this is a new Observation resource being created
      followUp = recFormToResource(this.props.formValues.values.followUp, 'Follow-Up', this.props.patient.resource.id, this.props.user.id, null);
      detailed = recFormToResource(this.props.formValues.values.detailed, 'Detailed', this.props.patient.resource.id, this.props.user.id, null);
    } else {
      /*
      * Reasoning for the parameter values:
      * - this.props.recommendations.followUp.resource: this is the Observation resource that exists, unless it's a POST where this would be null
      */
      // Use: if an existing Observation resource is being edited, this part executes
      followUp = recFormToResource(this.props.formValues.values.followUp, 'Follow-Up', this.props.patient.resource.id, this.props.user.id, this.props.recommendations.followUp.resource);
      detailed = recFormToResource(this.props.formValues.values.detailed, 'Detailed', this.props.patient.resource.id, this.props.user.id, this.props.recommendations.detailed.resource);
    }

    // call to the backend to submit compiled Observation resources for follow-up and detailed recommendations
    this.props.submitRec(followUp, 'Follow-Up');
    this.props.submitRec(detailed, 'Detailed');
    // reset the response error object
    this.props.resetRecError();
  }

  handleChange() {
    // Use: make it known the the form fields are now "dirty" ...
    //      or have been changed since the last save/reload of the page
    this.setState({
      changed: true,
    });
  }

  componentDidMount() {
    // Use: check if clinician state object is null ...
    //      occurs when the user is not logged in and they try this url path
    if (this.props.user === null) {
      this.props.history.push('/');
    }

    // Use: reset request errors upon reloading
    this.props.resetRecError();
  }


  render() {
    return (
      <div>
        <TitlePage />
        <NavBar {...this.props} />
        {this.props.location.new ?
          <div>
            <Container fluid>
              <Row>
                <Col>
                  <p className="display-4" align="center">
                  Add Recommendation
                  </p>
                </Col>
              </Row>
            </Container>
            <RecommendationsForm
              handleSave={() => this.handleSave()}
              handleChange={() => this.handleChange()}
              hasRecommendation={hasKeys(this.props, 'recommendations.detailed.resource')}
              noError={this.props.recommendations.error}
              changed={this.state.changed}
            />
          </div>

          :
          <div>
            <Container fluid>
              <Row>
                <Col>
                  <p className="display-4" align="center">
                  Add Recommendation
                  </p>
                </Col>
              </Row>
            </Container>
            <RecommendationsForm
              handleSave={() => this.handleSave()}
              handleChange={() => this.handleChange()}
              hasRecommendation={hasKeys(this.props, 'recommendations.detailed.resource')}
              noError={this.props.recommendations.error}
              changed={this.state.changed}
              initialValues={this.props.recommendations.parsedResponse}
            />
          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  // formValues: state.form.recommendationsForm,
  formValues: Object.values(state.form)[0],
  recommendations: state.recommendations,
  patient: state.patient.patient,
  user: state.clinician.clinician,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      submitRec,
      resetRecError,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RecommendationsPage);



// WEBPACK FOOTER //
// ./src/components/RecommendationsPage/RecommendationsPage.js